import React, { useEffect, useState } from 'react';
import { groupBy } from 'lodash';
import { useConsolidationScoreInadimplenciaEvolucaoAcumulo } from './api/getConsolidationScoreInadimplenciaEvolucaoAcumulo';
import LoadingChart from '@/features/dashboard/components/LoadingChart';
import ColumnChartComPorcentagem from '@/components/Base/ColumnChartInadimplenciaAcumulo';
import ColumnChartComPorcentagemEvolucao from '@/components/Base/ColumnChartInadimplenciaEvolucao';
import { useAcumuloInadimplenciaMes } from './api/getAcumuloInadimplencia';

const ScoreInadimplenciaAcumulo = ({ year, month }) => {
  const { data, isFetched, isFetching } = useAcumuloInadimplenciaMes({
   year,
  });
  const [yearLocal, setYearLocal] = useState<number | null>(null);

  useEffect(() => {
    if (isFetched) {
      const currentYear = new Date().getFullYear();
      const listYears = Object.keys(groupBy(data, 'ano'))
        .map((item) => Number(item))
        .sort((a, b) => b - a);
      if (listYears.length) {
        setYearLocal(year === null ? currentYear : year);
      }
    }
  }, [isFetched, data, year]);

  return (
    <>
      <LoadingChart loading={isFetching} />
      {data && isFetched && <ColumnChartComPorcentagemEvolucao selectedData={data} title={'Acúmulo da inadimplência'} firstColor={'#e04a4c'} secondColor={'#dddddd'}  columnOne={'Valor inadimplente'} columnTwo={''} percentageName={''}/>}
    </>
  );
};

export default ScoreInadimplenciaAcumulo;
